module.exports = __webpack_public_path__ + "img/activity13.9ae7c694.jpg";